import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "../../blent-component/Select";
import { LabelButton } from "../../blent-component/Button";
import { ISelect } from "../../blent-component/Select";
import { ISelectMenuOption } from "../../blent-component/Select/interfaces";
import { Icon } from "../../blent-component/Icon";
import styles from "./styles.module.scss";

export const ManualAutoSelect = (
  props: ISelect & { changeToManual: () => void }
) => {
  const { t } = useTranslation();
  // const [autosuggest, setAutosuggest] = useState<boolean>(false);

  const newItem: ISelectMenuOption = {
    label: "",
    value: "",
    customDisplay: (
      <div className={styles.editButton}>
        <LabelButton
          icon={<Icon name="Pencil" />}
          size="s"
          auto
          label={t("enableEdit")}
          onClick={props.changeToManual}
          variant="secondary"
          corners="squared"
        />
      </div>
    ),
  };
  const options: ISelectMenuOption[] = props.options
    ? [...props.options, newItem]
    : [newItem];
  const newProps = { ...props, options };

  return <Select {...newProps} />;
};
